import * as actionTypes from "./actionTypes";
import { productService } from "../../service";
import { errorHelper } from "../../common/helpers";
import { constants } from "../../common/constants";
import { min } from "moment";

export function getProducts({
  page = constants.GET_ALL_ITEMS,
  filter,
  categoryId = constants.GET_ALL_ITEMS,
  reset,
} = {}) {
  return async (dispatch) => {
    try {
      if (reset == true) dispatch({ type: actionTypes.RESET_PRODUCTS });

      dispatch({ type: actionTypes.FETCH_PRODUCTS });

      const response = await productService.getAll(page, filter, categoryId);
      const data = response.data;
      //TODO: Delete this and yourself
      //FIXME: oof
      if (data.message) {
        dispatch({
          type: actionTypes.FETCH_PRODUCTS_FAILURE,
          payload: { error: data.message },
        });

        return;
      }

      dispatch({
        type: actionTypes.FETCH_PRODUCTS_SUCCESS,
        payload: {
          products: data.data,
          total: data.quantity,
          pageSize: data.pageSize,
        },
      });
    } catch (error) {
      errorHelper.handle(error, dispatch, actionTypes.FETCH_PRODUCTS_FAILURE);
    }
  };
}
export function resetProducts() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.RESET_PRODUCTS,
    });
  };
}
export function getProductsOffer({
  page = 1,
  filter = "",
  reset = false,
} = {}) {
  return async (dispatch) => {
    try {
      if (reset == true) dispatch({ type: actionTypes.RESET_PRODUCTS_OFFER });
      dispatch({ type: actionTypes.FETCH_PRODUCTS_OFFER });
      const response = await productService.getAll(
        page,
        filter,
        constants.GET_ALL_ITEMS
      );
      const data = response.data;
      if (data.message) {
        dispatch({
          type: actionTypes.FETCH_PRODUCTS_OFFER_FAILURE,
          payload: { error: data.message },
        });

        return;
      }

      dispatch({
        type: actionTypes.FETCH_PRODUCTS_OFFER_SUCCESS,
        payload: {
          products: data.data,
          total: data.quantity,
          pageSize: data.pageSize,
        },
      });
    } catch (error) {
      errorHelper.handle(
        error,
        dispatch,
        actionTypes.FETCH_PRODUCTS_OFFER_FAILURE
      );
    }
  };
}
export function resetProductsOffer() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.RESET_PRODUCTS_OFFER,
    });
  };
}
export function getProduct(id) {
  return async (dispatch) => {
    try {
      dispatch({ type: actionTypes.RESET_PRODUCT });
      dispatch({ type: actionTypes.FETCH_PRODUCT });

      const response = await productService.get(id);
      const data = response.data;

      if (data.message) {
        dispatch({
          type: actionTypes.FETCH_PRODUCT_FAILURE,
          payload: { error: data.message },
        });

        return;
      }

      dispatch({
        type: actionTypes.FETCH_PRODUCT_SUCCESS,
        payload: { product: data },
      });
    } catch (error) {
      errorHelper.handle(error, dispatch, actionTypes.FETCH_PRODUCT_FAILURE);
    }
  };
}

export function resetProduct() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.RESET_PRODUCT,
    });
  };
}

export function getProductStores(id) {
  return async (dispatch) => {
    try {
      // dispatch({ type: actionTypes.RESET_PRODUCTS_STORES })
      dispatch({ type: actionTypes.FETCH_PRODUCTS_STORES });
      const response = await productService.getProductStores(id);
      const data = response.data;

      dispatch({
        type: actionTypes.FETCH_PRODUCTS_STORES_SUCCESS,
        payload: { productStores: data.data },
      });
    } catch (error) {
      errorHelper.handle(
        error,
        dispatch,
        actionTypes.FETCH_PRODUCTS_STORES_FAILURE
      );
    }
  };
}

export function putProductStores(id, minStock, store_id) {
  return async (dispatch) => {
    try {
      // dispatch({ type: actionTypes.RESET_PRODUCTS_STORES })
      dispatch({ type: actionTypes.UPDATE_PRODUCT_STORES_STOCK });
      const response = await productService.putStockProductStores(
        id,
        minStock,
        store_id
      );
      const data = response.data;

      dispatch({
        type: actionTypes.UPDATE_PRODUCT_STORES_STOCK_SUCCESS,
        payload: { productStores: data.data },
      });
    } catch (error) {
      errorHelper.handle(
        error,
        dispatch,
        actionTypes.UPDATE_PRODUCT_STORES_STOCK_FAILURE
      );
    }
  };
}
export function resetStockProductStores() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.RESET_UPDATE_PRODUCT_STORES_STOCK,
    });
  };
}

export function resetProductStores() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.RESET_PRODUCTS_STORES,
    });
  };
}
export function createProduct(product, imgV, imgH) {
  return async (dispatch) => {
    try {
      dispatch({ type: actionTypes.CREATE_PRODUCT });

      const response = await productService.create(product, imgV, imgH);
      const data = response.data;

      if (data.message) {
        dispatch({
          type: actionTypes.CREATE_PRODUCT_FAILURE,
          payload: { error: data.message },
        });

        return;
      }

      dispatch({
        type: actionTypes.CREATE_PRODUCT_SUCCESS,
        payload: {
          product: data,
        },
      });

      dispatch({ type: actionTypes.RESET_CREATE_PRODUCT });
    } catch (error) {
      errorHelper.handle(error, dispatch, actionTypes.CREATE_PRODUCT_FAILURE);
    }
  };
}

export function resetCreateProduct() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.RESET_CREATE_PRODUCT,
    });
  };
}
export function updateProduct(id, product, imgV, imgH) {
  return async (dispatch) => {
    try {
      dispatch({ type: actionTypes.UPDATE_PRODUCT });

      const response = await productService.update(id, product, imgV, imgH);
      const data = response.data;

      dispatch({
        type: actionTypes.UPDATE_PRODUCT_SUCCESS,
        payload: { product: data },
      });

      dispatch({ type: actionTypes.RESET_UPDATE_PRODUCT });
      // dispatch({ type: actionTypes.RESET_PRODUCT })
    } catch (error) {
      errorHelper.handle(error, dispatch, actionTypes.UPDATE_PRODUCT_FAILURE);
    }
  };
}
export function resetUpdateProduct() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.RESET_UPDATE_PRODUCT,
    });
  };
}

export function deleteProduct(id) {
  return async (dispatch) => {
    try {
      dispatch({ type: actionTypes.DELETE_PRODUCT });

      const response = await productService.deleteProduct(id);

      dispatch({
        type: actionTypes.DELETE_PRODUCT_SUCCESS,
        payload: {
          product: { id },
        },
      });

      dispatch({ type: actionTypes.RESET_DELETE_PRODUCT });
    } catch (error) {
      errorHelper.handle(error, dispatch, actionTypes.DELETE_PRODUCT_FAILURE);
    }
  };
}

export function getProductOrders({
  id,
  page = constants.GET_ALL_ITEMS,
  reset = false,
} = {}) {
  return async (dispatch) => {
    try {
      if (reset == true) dispatch({ type: actionTypes.RESET_PRODUCT_ORDERS });

      dispatch({ type: actionTypes.FETCH_PRODUCT_ORDERS });

      const response = await productService.getOrders(id, page);
      const data = response.data;

      if (data.message) {
        dispatch({
          type: actionTypes.FETCH_PRODUCT_ORDERS_FAILURE,
          payload: { error: data.message },
        });

        return;
      }

      dispatch({
        type: actionTypes.FETCH_PRODUCT_ORDERS_SUCCESS,
        payload: {
          orders: data.data,
          total: data.quantity,
          pageSize: data.pageSize,
        },
      });
    } catch (error) {
      errorHelper.handle(
        error,
        dispatch,
        actionTypes.FETCH_PRODUCT_ORDERS_FAILURE
      );
    }
  };
}

export function createProductOrder(id, order) {
  return async (dispatch) => {
    try {
      dispatch({ type: actionTypes.CREATE_PRODUCT_ORDER });

      const response = await productService.createOrder(id, order);
      const data = response.data;

      if (data.message) {
        dispatch({
          type: actionTypes.CREATE_PRODUCT_ORDER_FAILURE,
          payload: { error: data.message },
        });

        return;
      }

      dispatch({
        type: actionTypes.CREATE_PRODUCT_ORDER_SUCCESS,
        payload: {
          order: data,
        },
      });

      dispatch({ type: actionTypes.RESET_CREATE_PRODUCT_ORDER });
    } catch (error) {
      errorHelper.handle(
        error,
        dispatch,
        actionTypes.CREATE_PRODUCT_ORDER_FAILURE
      );
    }
  };
}

export function deleteProductOrder(id) {
  return async (dispatch) => {
    try {
      dispatch({ type: actionTypes.DELETE_PRODUCT_ORDER });

      const response = await productService.deleteProductOrder(id);

      dispatch({
        type: actionTypes.DELETE_PRODUCT_ORDER_SUCCESS,
        payload: {
          order: { id },
        },
      });

      dispatch({ type: actionTypes.RESET_DELETE_PRODUCT_ORDER });
    } catch (error) {
      errorHelper.handle(
        error,
        dispatch,
        actionTypes.DELETE_PRODUCT_ORDER_FAILURE
      );
    }
  };
}



// WEBPACK FOOTER //
// ./src/store/product/actions.js